<template>
  <section
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
  >
    <div class="tw-w-full tw-text-black">
      <div
        class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-p-6 md:tw-w-[80%] lg:tw-w-full lg:tw-flex-row"
        :style="`border-radius: var(--rounded); background-color: var(--c-${vars.cardBackgroundColor ? vars.cardBackgroundColor : 'white'})`"
      >
        <div class="tw-w-full lg:tw-max-w-[465px]">
          <LibraryImage :w-ratio="1" :h-ratio="1.45" :src="vars.guideImage" style="border-radius: var(--rounded)" />
        </div>
        <div class="tw-flex tw-w-full tw-flex-col tw-px-6 md:tw-px-10 xl:tw-px-20">
          <div class="tw-pb-8 tw-text-black" v-html="vars.titleText"></div>

          <library-form
            v-if="form"
            :form="form"
            version="v2"
            :component="component"
            :isFormNameVisible="false"
          ></library-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'GuideSection',

  mixins: [ComponentMixin],

  data() {
    return {
      swiper: null,
      form: null,
      canPaginateBack: true,
      canPaginateNext: true,
      selectedGuide: null,
      popupConfig: {
        isActive: false,
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.guideForm);
  },
});
</script>
